import { TranslateService } from "@ngx-translate/core";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { LeverantorsorderDetailRequestDTO } from "../models/LeverantorsorderDetailRequestDTO";

export class LeverantorsorderValidation {
    static init(
        translateService: TranslateService,
        levorder: LeverantorsorderDetailRequestDTO): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: translateService.instant("LEVERANTORSORDER_DETAIL_HVKODLEV_VALIDATION") },
                model: () => levorder.leverantor,
                name: "leverantor",
                required: true
            }
        ]);
        return context;
    }
}
